import React from 'react';
import videoGuideSvg from '../../../../Assets/Icons/videoGuide.svg';
import useLanguage from '../../../../Services/Language/useLanguageHook';
import trackingService from '../../../../Services/Tracking/TrackingService';
import styles from './TutorialLink.module.scss';

interface ITutorialLinkProps {
    link: string;
}

const TutorialLink: React.FC<ITutorialLinkProps> = (props: ITutorialLinkProps) => {
    const [translations] = useLanguage();

    const handleClick = () => {
        trackingService.track({ eventCategory: 'TutorialLink', eventAction: 'TutorialLinkClicked', eventValue: props.link });
    };

    return (
        <div className={styles.tutorial_link}>
            <a target="_blank" rel="noopener noreferrer" href={props.link} onClick={handleClick}>
                <img src={videoGuideSvg} alt="#" />
                <span>{translations.text.videoGuide}</span>
            </a>
        </div>
    );
};

export default TutorialLink;
